import { render } from "./ReclamacaoTecnicaComercialFormulario.vue?vue&type=template&id=b873991c&scoped=true"
import script from "./ReclamacaoTecnicaComercialFormulario.vue?vue&type=script&lang=js"
export * from "./ReclamacaoTecnicaComercialFormulario.vue?vue&type=script&lang=js"

import "./ReclamacaoTecnicaComercialFormulario.vue?vue&type=style&index=0&id=b873991c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b873991c"]])

export default __exports__